"use client";

import React, { useEffect } from "react";
import ReactPlayer from "react-player";

interface YoutubeVideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    src: string;
    autoPlay?: boolean;
}

const YoutubeVideoModal: React.FC<YoutubeVideoModalProps> = ({ isOpen, onClose, src, autoPlay = true }) => {
    // Disable body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-60" onClick={onClose} />
            <div className="relative bg-black rounded-lg overflow-hidden shadow-lg w-full max-w-6xl z-10">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 z-20 bg-gray-600 text-white rounded-full p-1 w-7 h-7 flex items-center justify-center cursor-pointer hover:bg-gray-700"
                    aria-label="Close"
                >
                    ✕
                </button>
                <ReactPlayer
                    url={src}
                    width="100%"
                    height="570px"
                    playing={autoPlay}
                    controls
                    config={{
                        youtube: {
                            playerVars: {
                                autoplay: autoPlay ? 1 : 0,
                            },
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default YoutubeVideoModal;
